import { useState, useEffect } from 'react';
import { getWarehouseList, deleteWarehouse } from 'helpers/backend_helper';
import { Common } from 'helpers/common';
import filterDataBySearch from 'Common/filterDataBySearch';

export const useWarehouseList = () => {
    const [allWarehouse, setAllWarehouse] = useState<any[]>([]);
    const [warehouseList, setWarehouseList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const uiHelper = new Common();

    useEffect(() => {
        loadWarehouses(false);
    }, []);

    const loadWarehouses = async (reload: boolean) => {
        try {
            if (warehouseList.length === 0 || reload) {
                const response = await getWarehouseList();
                if (response) {
                    setWarehouseList(response.data as never[]);
                    setAllWarehouse(response.data as never[]);
                }
            }
        } catch (error) {
            console.error('Error loading warehouses:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (warehouseId: number) => {
        try {
            await deleteWarehouse(warehouseId);
            setWarehouseList((prevList) => prevList.filter((warehouse: any) => warehouse.id !== warehouseId));
            uiHelper.showSuccessMessage("Warehouse has been deleted successfully.");
            return true;
        } catch (error) {
            console.error('Error deleting warehouse:', error);
            return false;
        }
    };

    const updateWarehouseList = (result: any, isEdit: boolean, warehouseData: any) => {
        if (isEdit) {
            setWarehouseList((prevList) =>
                prevList.map((warehouse: any) =>
                    warehouse.id === warehouseData.id ? { ...result } : { ...warehouse }
                )
            );
        } else {
            setWarehouseList((prevList) => [{ ...result }, ...prevList]);
        }
    };

    const filterSearchData = (e: any) => {
        const search = e.target.value;
        const keysToSearch = ['name', 'location'];
        filterDataBySearch(allWarehouse, search, keysToSearch, setWarehouseList);
    };

    return {
        warehouseList,
        isLoading,
        handleDelete,
        updateWarehouseList,
        filterSearchData
    };
};